(() => {
  if (window.KKCartSportfluidUpgrade) return;

  const root = () => window.Shopify?.routes?.root || '/';

  const updateCart = async (updates) => {
    const response = await fetch(`${root()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || cart.message || 'Cart update failed');
    return cart;
  };

  const getCart = async () => {
    const response = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart read failed');
    return response.json();
  };

  const restoreOriginal = async (singleId, bundleId) => {
    const cart = await getCart();
    const singleLine = cart.items.find((item) => Number(item.variant_id) === singleId);
    const bundleLines = cart.items.filter((item) => Number(item.variant_id) === bundleId);
    const updates = {};

    bundleLines.forEach((item) => {
      updates[item.key] = 0;
    });
    if (!singleLine) updates[singleId] = 1;
    if (Object.keys(updates).length) await updateCart(updates);
  };

  window.KKCartSportfluidUpgrade = {
    replace: async (button) => {
      if (!button || button.disabled) return;

      const card = button.closest('[data-kk-cart-upgrade]');
      const status = card?.querySelector('.kk-cart-upgrade__status');
      const singleId = Number(button.dataset.singleId);
      const bundleId = Number(button.dataset.bundleId);
      const updates = { [button.dataset.singleKey]: 0, [bundleId]: 1 };

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (status) status.textContent = button.dataset.loading || '';

      try {
        const cart = await updateCart(updates);
        const singleLine = cart.items.find((item) => Number(item.variant_id) === singleId);
        const bundleLine = cart.items.find((item) => Number(item.variant_id) === bundleId);

        if (singleLine || !bundleLine || bundleLine.quantity !== 1) {
          await restoreOriginal(singleId, bundleId);
          throw new Error('Unexpected cart state');
        }

        window.location.assign(button.dataset.cartUrl || `${root()}cart`);
      } catch (error) {
        try {
          await restoreOriginal(singleId, bundleId);
        } catch (restoreError) {
          console.error('Sportfluid cart upgrade rollback failed', restoreError);
        }
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (status) status.textContent = button.dataset.error || '';
        console.error('Sportfluid cart upgrade failed', error);
      }
    },
  };
})();

